import { TickProps } from 'bold-ui/lib/components/Chart/Tick'

export function TickSemanaGestacional(props: Readonly<TickProps>) {
  const {
    payload: { value },
    ...rest
  } = props

  return (
    <text dy={15} {...rest}>
      {value}
    </text>
  )
}
